import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useIsMobile } from 'hooks/useIsMobile';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import beneficios from './beneficios.module.sass'

import { encodeStorage } from 'pages/Header/Content/functions/storageBase64';
import { ModalLoadingCredit } from 'components/Loading';
import { useWebview } from 'hooks/useWebview';

import { AdministraCredito, ComoFunciona, Cotizador, DescargaApp, First, Second, SolicitudApp, Third, useHomeRedirect } from './index';


export function BeneficiosExternal() {

    const { isMobile } = useIsMobile();
    const [loading, setLoading] = useState(true)

    const { typeNav, typeMovile } = useWebview()

    const {        
        login,
        credit,
        sears_numero_internet,
        cardending,
        estadoCredito,
        flagAceptoCredito
    } = useHomeRedirect()

    useEffect(() => {

        if(credit && login && flagAceptoCredito === 200){
            setTimeout(function(){
                window.location.href = `${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`
            },500)
        }
        else{
            setLoading(false)
        }
    },[login, credit])

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Benefits landing  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
    }, [])

    const structData = `{
        "@context": "http://schema.org/",
        "@type": "Product",
        "name": "Crédito Claroshop",
        "description": "Paga hasta en 24 meses y obtén 10% de descuento en tu primera compra",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "25592 ",
          "bestRating": "5",
          "worstRating": "1"
        },
        "image": "https://www.claroshop.com/c/algolia/images/claro-shop-1.jpeg",
        "brand": { "@type": "Thing", "name": "Crédito Claroshop" }
    }`
    
    return (
        <>
            <Helmet>
                <title>{'Crédito Claroshop: Paga hasta 24 meses  + 10% de descuento'}</title>
                <link rel="canonical" href={`https://www.claroshop.com/credito-claroshop/beneficios`} />

                <meta name="Description" content={`Compra sin tarjeta y paga hasta en 24 meses con Crédito Claroshop. Sácalo en minutos y obtén 10% de descuento en tu primera compra. Crédito hasta $30,000MXN`} />
            
                <meta property="og:locale" content="es_MX" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Crédito Claroshop: Paga hasta 24 meses  + 10% de descuento" />
                <meta property="og:description" content="Compra sin tarjeta y paga hasta en 24 meses con Crédito Claroshop. Sácalo en minutos y obtén 10% de descuento en tu primera compra. Crédito hasta $30,000MXN." />
                <meta property="og:url" content="https://www.claroshop.com/credito-claroshop/beneficios" />
                <meta property="og:site_name" content="Claroshop" />
                <meta property="og:image" content="https://www.claroshop.com/c/credito/credito-og.jpg" />
                <meta property="og:image:secure_url" content="https://www.claroshop.com/c/credito/credito-og.jpg" />
                <meta property="og:image:width" content="1500" />
                <meta property="og:image:height" content="700" />
                <meta property="og:image:alt" content="Claroshop" />
                <meta property="og:image:type" content="image/png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Crédito Claroshop: Paga hasta 24 meses  + 10% de descuento" />
                <meta name="twitter:description" content="Compra sin tarjeta y paga hasta en 24 meses con Crédito Claroshop. Sácalo en minutos y obtén 10% de descuento en tu primera compra. Crédito hasta $30,000MXN." />
                <meta name="twitter:image" content="https://www.claroshop.com/c/credito/credito-og.jpg" />
                <meta name="twitter:label2" content="Productos" />
                <meta name="twitter:data2" content="567" />

                <meta name="robots" content="follow, index" />

                <script type="application/ld+json">
                    { structData }
                </script>
            </Helmet>
            {loading && <ModalLoadingCredit />}
            <div className={isMobile === "desktop" ? "" : "homeMobile"}>
                {isMobile === "desktop"
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={"Crédito Claroshop"} type="backFull" goBack={"homeClaro"}/>
                }
                <main>
                    <First />
                    <Second />
                    <Third typeNav={typeNav} typeMovile={typeMovile} />
                    <Cotizador />
                    <ComoFunciona typeNav={'movil'} login={login} credit={credit} />
                    <AdministraCredito />
                    <DescargaApp typeNav={'movil'} typeMovile={typeMovile} />
                    <SolicitudApp typeNav={'movil'} login={login} />
                </main>
                <Footer type="complete" />
            </div>
        </>
    );
}